"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addMediaQueryRes = exports.addMediaQuery = void 0;
const addMediaQuery = ({ selector, styleStr, device = 'nodevice', }) => {
    let css = '';
    // 1) deciding media query
    switch (device) {
        case 'desktop':
            css = `${css}@media screen and (min-width: 1260px){`;
            break;
        case 'mobile':
            css = `${css}@media screen and (min-width: 0px) and (max-width: 768px) {`;
            break;
        case 'mobileWhenNoTablet':
            css = `${css}@media screen and (min-width: 0px) and (max-width: 1260px) {`;
            break;
        case 'nodevice':
            css = '';
            break;
        case 'tablet':
        default:
            css = `${css}@media screen and (min-width: 768px) and (max-width: 1260px) {`;
            break;
    }
    // appending instructions
    css += `${selector} {${styleStr}}${device === 'nodevice' ? '{' : ''}`;
    css += '}';
    const head = document.head || document.getElementsByTagName('head')[0];
    const style = document.createElement('style');
    style.type = 'text/css';
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    }
    else {
        style.appendChild(document.createTextNode(css));
    }
    head.appendChild(style);
};
exports.addMediaQuery = addMediaQuery;
const addMediaQueryRes = ({ selector, styleStr, device = 'nodevice', }) => {
    let css = '';
    // 1) deciding media query
    switch (device) {
        case 'desktop':
            css = `${css}@media screen and (min-width: 1260px){`;
            break;
        case 'mobile':
            css = `${css}@media screen and (min-width: 0px) and (max-width: 768px) {`;
            break;
        case 'mobileWhenNoTablet':
            css = `${css}@media screen and (min-width: 0px) and (max-width: 1260px) {`;
            break;
        case 'nodevice':
            css = '';
            break;
        case 'tablet':
        default:
            css = `${css}@media screen and (min-width: 768px) and (max-width: 1260px) {`;
            break;
    }
    // appending instructions
    css += `${selector} {${styleStr}}${device === 'nodevice' ? '{' : ''}`;
    css += '}';
    return css;
};
exports.addMediaQueryRes = addMediaQueryRes;
//# sourceMappingURL=index.js.map